import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_drzk7thxry: FaireBrandEntity = {
  token: "b_drzk7thxry",
  type: "brand",
  name: "Designature New York",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ec7076b3c292d7d09192fd20b4bb61ed859a1a95718665ea73c5918e5814b44.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2d121e1c24ecfe4a50e2a491329f9b80ab40c5a035cbadca2d2fc0ec083b6541.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9ec7076b3c292d7d09192fd20b4bb61ed859a1a95718665ea73c5918e5814b44.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2d121e1c24ecfe4a50e2a491329f9b80ab40c5a035cbadca2d2fc0ec083b6541.jpeg",
  location: "New York City, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 122,
  isTopShop: true,
  isInsider: true,
  description:
    'Welcome to DESIGNATURE, your premier destination for wholesale fashion jewelry, centrally located in the heart of Manhattan, New York City.\n\nOur brand name, DESIGNATURE, is a fusion of "Design" and "Signature," embodying our commitment to crafting unique and signature pieces that resonate with the dynamic and vibrant creative energy of New York City.\n\nExplore our curated collections and experience the soul of New York\'s design evolution through DESIGNATURE. Join us on this journey where every piece tells a story, capturing the spirit of the city that never sleeps.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.231Z",
    importedBy: "entity-db-cli",
  },
};
